import { Component } from "@angular/core";

@Component({
  selector: "icon-beneficios-reforma-flecha-menu",
  templateUrl: "./beneficios-reforma-flecha-menu.svg",
  standalone: true,
})
export class BeneficiosReformaFlechaMenuComponent {}